export enum ServiceSectionIds {
  SERVICE_1 = '8f78acb6-0e49-478c-86c4-9fef5c404cde',
  SERVICE_2 = '9f60b3d8-be59-4aa8-8deb-d773b99cc4e4',
}
